'use client'

import { useTranslations } from 'next-intl'
import { Days, IOpeningHour } from '@/api/restaurants/types/restaurant-types'
import { parseDayOfWeek } from '@/features/restaurants/utils/parse-day-of-week'
import { parseReadableDay } from '@/features/restaurants/utils/parse-readable-day'
import { parseReadableDayOpeningHours } from '@/features/restaurants/utils/parse-readable-day-opening-hours'
import { cn } from '@/utils/styles/cn'

interface IRestaurantDetailOpeningHoursListProps {
    getDayOpeningHours: (dayNumber: number) => IOpeningHour[] | null | undefined
    className?: string
}

export const RestaurantDetailOpeningHoursList = ({
    getDayOpeningHours,
    className,
}: IRestaurantDetailOpeningHoursListProps) => {
    const t = useTranslations()

    const todayDay = parseDayOfWeek(new Date().getDay())

    return (
        <div className={cn('w-full flex flex-col divide-y divide-border-secondary', className)}>
            {Object.values(Days).map((day, index) => {
                const isToday = todayDay === day

                const readableDayOpeningHours = parseReadableDayOpeningHours(
                    getDayOpeningHours(index + 1) ?? null,
                    t
                )

                return (
                    <div
                        key={index + 'restaurant-detail-opening-hours'}
                        className={cn(
                            'flex items-center justify-between gap-x-6 py-2 text-p-sm md:text-p-md',
                            isToday && 'font-semibold'
                        )}
                    >
                        <span className={cn('text-fg-secondary', isToday && 'text-fg-primary')}>
                            {parseReadableDay(day, t)}
                        </span>

                        <span className="whitespace-nowrap">{readableDayOpeningHours}</span>
                    </div>
                )
            })}
        </div>
    )
}
